import { useApolloClient, gql, makeVar, useReactiveVar, NetworkStatus } from '@apollo/client';

import DataProvider from './DataProvider';

export { configFlagsApolloClient, disposeConfigFlagsWsClient } from './configFlagsApolloClient';

export { useApolloClient, gql, makeVar, useReactiveVar, NetworkStatus };

export type { Reference, TypePolicy, FieldPolicy, ObservableQuery } from '@apollo/client';
export type { ReadFieldFunction } from '@apollo/client/cache/core/types/common';

export default DataProvider;
